/* eslint-disable @typescript-eslint/no-explicit-any */
import { getFunctions, httpsCallable } from "firebase/functions";
import Config from "@/config/Config";
import { ConnectedAccountResponse } from "@models/ConnectedAccountResponse";
import Stripe from "stripe";

class ConnectedAccountDataService {
  warmup(): void {
    const functions = getFunctions();
    const completeTransactionDirect = httpsCallable(functions, Config.functions.CreateConnectedAccount);
    completeTransactionDirect({
      warmup: true,
    });
  }

  async createConnectedAccount(eventId: string): Promise<ConnectedAccountResponse> {
    const functions = getFunctions();
    const createConnectedAccountFunc = httpsCallable(functions, Config.functions.CreateConnectedAccount);
    const result = (await createConnectedAccountFunc({
      eventId,
    })) as any;

    if (result.data?.error) {
      throw result;
    }

    return result.data as ConnectedAccountResponse;
  }

  async createConnectedAccountSession(eventId: string): Promise<Stripe.Response<any>> {
    const functions = getFunctions();
    const createConnectedAccountSessionFunc = httpsCallable(functions, Config.functions.CreateConnectedAccountSession);
    const result = (await createConnectedAccountSessionFunc({
      eventId,
    })) as any;

    if (result.data?.error) {
      throw result;
    }

    return result.data as ConnectedAccountResponse;
  }

  async copyConnectedAccount(
    sourceEventId: string,
    targetEventId: string
  ): Promise<ConnectedAccountResponse> {
    const functions = getFunctions();
    const copyConnectedAccountFunc = httpsCallable(functions, Config.functions.CopyConnectedAccount);
    const result = (await copyConnectedAccountFunc({
      sourceEventId,
      targetEventId,
    })) as any;

    if (result.data?.error) {
      throw result;
    }

    return result.data as ConnectedAccountResponse;
  }

}

export default new ConnectedAccountDataService();
